"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findIndexWith = exports.findIndex = void 0;

var _isMatch = require("../is-match/is-match");

/**
 * Find the position of first element that satisfies a function
 *
 * @param  {Function}    fn      Match function
 * @param  {Object[]}    source  Source array
 *
 * @return {number}
 *
 * @name findIndex
 * @tag Array
 * @signature (fn: Function) => (source: Object[]): number
 *
 * @example
 * const comments = [{ id: 1, body: "" }, { id: 2, body: "dolor" }]
 *
 * findIndex(item => item.id === 2)(comments)
 * // => 1
 * findIndex(item => item.id === 3)(comments)
 * // => -1
 */
var findIndex = function findIndex(fn) {
  return function (source) {
    for (var i = 0, length = source.length; i < length; i++) {
      var found = fn(source[i], i, source);

      if (found === true) {
        return i;
      }
    }

    return -1;
  };
};

exports.findIndex = findIndex;

var findIndexWith = function findIndexWith(subset) {
  return findIndex((0, _isMatch.isMatch)(subset));
};

exports.findIndexWith = findIndexWith;